// extracted by mini-css-extract-plugin
export var $animation_name = "ThinButton-module--$animation_name--92961";
export var button = "ThinButton-module--button--cc48d";
export var button__icon = "ThinButton-module--button__icon--594d3";
export var button__link = "ThinButton-module--button__link--1ba3a";